import { Typography } from '@material-ui/core'

import { getTranslate } from '../../../localization'
import useStyles from './styles/ReservationNumbersModalTableHead.styles'

const ReservationNumbersModalTableHead = () => {
  const classes = useStyles()
  return (
    <div className={classes.tableHead}>
      <Typography variant="body1">{getTranslate('#')}</Typography>
      <Typography variant="body1">{getTranslate('In Booking List')}</Typography>
      <Typography variant="body1">
        {getTranslate('In Allocate History')}
      </Typography>
    </div>
  )
}
export default ReservationNumbersModalTableHead
